<div
  *ngFor="let item of items; let idx = index"
  class="item-accordion"
  [class.is-active]="openedIndex === idx"
>
  <button type="button" class="item-accordion__header" (click)="toggle(idx)">
    <span class="item-accordion__title">
      {{ item?.title | translate }}
    </span>

    <svg-icon src="defense-expand.svg" class="item-accordion__btn"/>
  </button>

  <div class="item-accordion__wrapper">
    <div class="item-accordion__content" [innerHTML]="item?.content | translate"></div>
  </div>
</div>
